export default __webpack_public_path__ + "static/media/pharmacy.a69fe7b7.svg";